import {Dispatch, SetStateAction} from 'react';
import {useNavigate} from 'react-router-dom';
import machineIcon from '../../../../assets/image/inputGroups/machinery.svg';
import {StoreOrderSteps} from '../../../../services/hookService/getOrderDetails/helper';
import {
  IStoreOrder,
  OrderStepTypes,
} from '../../../../services/hookService/getUserOrderList/types';
import {getPersianDateTime} from '../../../../utilities/helper/GetPersianDateTime';
import ProductIcon from '../../../farm/myStore/pages/settlementAndPayouts/components/ProductIcon';
import InfoRow from '../../../shopping-basket/ItemCard/InfoRow';
import {AllPaymentTypeToPersian} from '../../../shopping-basket/cash-payment/utils/helpers';

interface IProps {
  storeOrder: IStoreOrder;
  parentOrderGuid: string;
  selectedTab?: OrderStepTypes;
  setOpenPendingBottomSheet?: Dispatch<SetStateAction<boolean>>;
}

const MyOrderItem = ({
  storeOrder,
  parentOrderGuid,
  selectedTab,
  setOpenPendingBottomSheet,
}: IProps) => {
  const navigate = useNavigate();

  const handleOrderClick = () => {
    switch (true) {
      case selectedTab === 'pending_approval' &&
        storeOrder?.step === StoreOrderSteps.PENDING_PAYMENT_REVIEW:
        setOpenPendingBottomSheet?.(true);
        break;

      case selectedTab === 'canceled':
        break;

      default:
        navigate(`/my-orders/${storeOrder?.guid}/${parentOrderGuid}`);
        break;
    }
  };

  return (
    <div className="relative space-y-3 cardItem" onClick={handleOrderClick}>
      {/* PRODUCT IMAGES */}
      <div className="grid grid-cols-3 w-[70%] gap-2 py-2 justify-items-start">
        {storeOrder?.order_items.map(item => (
          <ProductIcon
            key={item.guid}
            icon={item.image ?? item.sub_brand_image ?? machineIcon}
            count={item.quantity}
          />
        ))}
      </div>

      {/* STATUS BADGES */}
      {selectedTab === 'incomplete' &&
        storeOrder?.step !== StoreOrderSteps.PREPAID && (
          <div className="absolute px-2.5 text-sm text-red-600 rounded-2xl top-2 left-5 bg-red-50">
            در انتظار پرداخت
          </div>
        )}

      {selectedTab === 'incomplete' &&
        storeOrder?.step === StoreOrderSteps.PREPAID && (
          <div className="absolute px-2.5 text-sm text-amber-700 rounded-2xl top-2 left-5 bg-amber-50">
            پیش پرداخت شده
          </div>
        )}

      {selectedTab === 'canceled' && (
        <div className="absolute px-2.5 text-sm text-red-600 rounded-2xl top-2 left-5 bg-red-50">
          لغوشده
        </div>
      )}

      {/* ORDER INFO */}
      <InfoRow
        icon="icon-nameCalendar"
        label="تاریخ ثبت سفارش"
        value={getPersianDateTime(storeOrder?.created_at) ?? 'تاریخ نامعین'}
      />

      {selectedTab === 'canceled' ? (
        <InfoRow
          icon="icon-nameCalendar"
          label="تاریخ لغو سفارش"
          value={getPersianDateTime(storeOrder?.rejected_at) ?? 'تاریخ نامعین'}
        />
      ) : (
        <InfoRow
          icon="icon-nameCalendar"
          label="تاریخ تامین سفارش"
          value={getPersianDateTime(storeOrder?.supply_date) ?? 'تاریخ نامعین'}
        />
      )}

      {Boolean(storeOrder?.payment_type) &&
        (selectedTab === 'pending_approval' ||
          selectedTab === 'supplying' ||
          selectedTab === 'delivered') && (
          <InfoRow
            icon="icon-nameWallet-out"
            label="نوع پرداخت"
            value={AllPaymentTypeToPersian[storeOrder?.payment_type]}
          />
        )}
    </div>
  );
};

export default MyOrderItem;
